import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth';
import base from './modules/base';
import collectfee from './modules/fees/collectfee';
import feeSession from './modules/fees/feeSession';
import tour from './modules/tour';
import utils from './modules/utils';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    base,
    auth,
    collectfee,
    feeSession,
    tour,
    utils,
  }
})

export default store;

// Cypress automatically sets window.Cypress by default
if (window.Cypress) {
  window.__store__ = store;
}